export default __webpack_public_path__ + "static/media/onlyfans.fcb61325.svg";